<div class="country-select" [class.country-select--glass]="variant === 'glass'">
  @if (variant === 'glass') {
    <div class="field__control">
      @if (icon) {
        <span class="material-icons field__icon">{{ icon }}</span>
      }
      <input
        [id]="inputId"
        type="text"
        placeholder=" "
        [value]="displayValue"
        [disabled]="disabled"
        (focus)="onFocus()"
        (input)="onInput($event)"
        (blur)="onBlur()"
        (keydown)="onKeydown($event)"
        autocomplete="off"
      />
      <label [for]="inputId">{{ label }}</label>
    </div>

    @if (isOpen()) {
      @if (filtered.length) {
        <ul class="cs-dropdown">
          @for (c of filtered; track c.code; let i = $index) {
            <li
              [class.active]="i === highlightedIndex()"
              (mousedown)="selectCountry(c); $event.preventDefault()"
            >
              <span class="cs-name">{{ c.name }}</span>
              <span class="cs-code">{{ c.code }}</span>
            </li>
          }
        </ul>
      } @else {
        <div class="cs-empty">No countries match "{{ query() }}"</div>
      }
    }
  } @else {
    <mat-form-field appearance="outline" class="country-field">
      <mat-label>{{ label }}</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input
        matInput
        [(ngModel)]="matSelection"
        [matAutocomplete]="auto"
        [placeholder]="placeholder"
        [disabled]="disabled"
        (blur)="onTouched()"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayCountry"
        (optionSelected)="onOptionSelected($event.option.value)"
      >
        @for (c of filteredCountries; track c.code) {
          <mat-option [value]="c">{{ c.name }} ({{ c.code }})</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  }
</div>
